import {
  ConsumerLoginRequest,
  ConsumerLoginResponse,
} from './dtos/consumer-login'
import { AxiosResponse } from 'axios'
import api from '../api'

export const consumerlogin = async (
  dados: ConsumerLoginRequest
): Promise<[ConsumerLoginResponse | null, any]> => {
  try {
    const { data } = await api.post<
      ConsumerLoginRequest,
      AxiosResponse<ConsumerLoginResponse>
    >('/canais/login', dados)

    return [data, null]
  } catch (error) {
    return [null, error]
  }
}
